import { render, staticRenderFns } from "./Blockquote.vue?vue&type=template&id=5d8fdfec&scoped=true&"
import script from "./Blockquote.vue?vue&type=script&lang=js&"
export * from "./Blockquote.vue?vue&type=script&lang=js&"
import style0 from "./Blockquote.vue?vue&type=style&index=0&id=5d8fdfec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8fdfec",
  null
  
)

export default component.exports